/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClusterMetricsId } from './ClusterMetricsId';
import {
    ClusterMetricsIdFromJSON,
    ClusterMetricsIdFromJSONTyped,
    ClusterMetricsIdToJSON,
} from './ClusterMetricsId';

/**
 * 
 * @export
 * @interface ClusterAlertsSchema
 */
export interface ClusterAlertsSchema {
    /**
     * 
     * @type {number}
     * @memberof ClusterAlertsSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ClusterAlertsSchema
     */
    level: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterAlertsSchema
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterAlertsSchema
     */
    originalMessage: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterAlertsSchema
     */
    coiledMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ClusterAlertsSchema
     */
    recommendation?: string;
    /**
     * 
     * @type {number}
     * @memberof ClusterAlertsSchema
     */
    errorType: number;
    /**
     * 
     * @type {number}
     * @memberof ClusterAlertsSchema
     */
    clusterId: number;
    /**
     * 
     * @type {object}
     * @memberof ClusterAlertsSchema
     */
    label?: object;
    /**
     * 
     * @type {ClusterMetricsId}
     * @memberof ClusterAlertsSchema
     */
    clusterMetrics?: ClusterMetricsId;
}

/**
 * Check if a given object implements the ClusterAlertsSchema interface.
 */
export function instanceOfClusterAlertsSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "level" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "originalMessage" in value;
    isInstance = isInstance && "errorType" in value;
    isInstance = isInstance && "clusterId" in value;

    return isInstance;
}

export function ClusterAlertsSchemaFromJSON(json: any): ClusterAlertsSchema {
    return ClusterAlertsSchemaFromJSONTyped(json, false);
}

export function ClusterAlertsSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClusterAlertsSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'level': json['level'],
        'title': json['title'],
        'originalMessage': json['original_message'],
        'coiledMessage': !exists(json, 'coiled_message') ? undefined : json['coiled_message'],
        'recommendation': !exists(json, 'recommendation') ? undefined : json['recommendation'],
        'errorType': json['error_type'],
        'clusterId': json['cluster_id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'clusterMetrics': !exists(json, 'cluster_metrics') ? undefined : ClusterMetricsIdFromJSON(json['cluster_metrics']),
    };
}

export function ClusterAlertsSchemaToJSON(value?: ClusterAlertsSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'level': value.level,
        'title': value.title,
        'original_message': value.originalMessage,
        'coiled_message': value.coiledMessage,
        'recommendation': value.recommendation,
        'error_type': value.errorType,
        'cluster_id': value.clusterId,
        'label': value.label,
        'cluster_metrics': ClusterMetricsIdToJSON(value.clusterMetrics),
    };
}

